import { Check, HelpCircle, X } from "lucide-react";

const OPTIONS = [
  { value: "yes", label: "Yes", sub: "I'll be there", icon: Check, on: "border-emerald-500 bg-emerald-50 text-emerald-800" },
  { value: "maybe", label: "Maybe", sub: "Trying to make it", icon: HelpCircle, on: "border-amber-500 bg-amber-50 text-amber-800" },
  { value: "no", label: "No", sub: "Can't make it", icon: X, on: "border-red-500 bg-red-50 text-red-800" },
];

export const ResponsePicker = ({ value, onChange }) => (
  <div className="grid grid-cols-3 gap-2" role="radiogroup" data-testid="rsvp-response-group">
    {OPTIONS.map(({ value: v, label, sub, icon: Icon, on }) => (
      <button
        key={v}
        type="button"
        role="radio"
        aria-checked={value === v}
        data-testid={`rsvp-response-${v}`}
        onClick={() => onChange(v)}
        className={`flex flex-col items-center gap-1 rounded-2xl border-2 px-2 py-3 text-center transition-[background-color,border-color,transform] duration-200 active:scale-95 ${
          value === v ? on : "border-slate-200 bg-white text-slate-600 hover:border-slate-300"
        }`}
      >
        <Icon className="h-5 w-5" />
        <span className="text-sm font-bold">{label}</span>
        <span className="text-[11px] leading-tight opacity-75">{sub}</span>
      </button>
    ))}
  </div>
);
